import Link from "next/link";
import { listFooterPages } from "@/lib/pages-repo";

const FOOTER_COLS = [
  {
    title: "Chuyên mục",
    items: [
      { label: "Crypto", href: "/category/crypto" },
      { label: "Chứng khoán", href: "/category/chung-khoan" },
      { label: "Vàng", href: "/category/vang" },
      { label: "Forex", href: "/category/forex" },
      { label: "Phân tích", href: "/category/phan-tich" },
      { label: "Tin nóng", href: "/category/tin-nong" },
    ],
  },
  {
    title: "Về Finzone",
    items: [
      { label: "Giới thiệu", href: "/gioi-thieu" },
      { label: "Liên hệ", href: "/lien-he" },
      { label: "Cộng đồng", href: "/cong-dong" },
    ],
  },
  {
    title: "Chính sách",
    items: [
      { label: "Chính sách biên tập", href: "/chinh-sach-bien-tap" },
      { label: "Miễn trừ đầu tư", href: "/mien-tru-dau-tu" },
      { label: "Bảo mật", href: "/bao-mat" },
    ],
  },
  {
    title: "Theo dõi",
    items: [
      { label: "Newsletter", href: "/cong-dong#newsletter" },
      { label: "Telegram", href: "https://t.me/finzonenetwork" },
      { label: "Zalo Group", href: "https://zalo.me/g/lkjhonloinvrmnm9xdib" },
      { label: "Facebook", href: "https://www.facebook.com/finzonenetwork" },
      { label: "RSS", href: "/feed.xml" },
    ],
  },
];

export async function Footer() {
  // Pull admin-managed pages flagged showInFooter — append to the relevant column
  // ("Về Finzone" by default since these are usually About/Editorial-style pages)
  let cmsPages: Array<{ label: string; href: string }> = [];
  try {
    const pages = await listFooterPages();
    cmsPages = pages
      .filter((p) => !["gioi-thieu", "lien-he", "cong-dong"].includes(p.slug))
      .map((p) => ({ label: p.title, href: `/${p.slug}` }));
  } catch (e) {
    console.error("[footer] listFooterPages failed:", e);
  }

  const cols = FOOTER_COLS.map((col) =>
    col.title === "Về Finzone" && cmsPages.length > 0
      ? { ...col, items: [...col.items, ...cmsPages] }
      : col,
  );

  return (
    <footer
      className="border-t hairline mt-12"
      style={{ background: "var(--paper)" }}
    >
      <div className="mx-auto max-w-[var(--container-content)] px-6 lg:px-10 py-12 lg:py-16">
        {/* Centered masthead repeat */}
        <div className="text-center mb-12">
          <Link href="/" className="logo-display block" aria-label="Finzone">
            Finzone
          </Link>
          <p className="eyebrow mt-3">Trang tin tài chính · Đầu tư · Phân tích</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-4xl mx-auto text-center">
          {cols.map((col) => (
            <div key={col.title}>
              <div className="eyebrow mb-3">{col.title}</div>
              <ul className="space-y-1.5 text-[13px]" style={{ color: "var(--ink-2)" }}>
                {col.items.map((it) => (
                  <li key={it.href}>
                    <Link
                      href={it.href}
                      target={it.href.startsWith("http") ? "_blank" : undefined}
                      rel={it.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="hover:text-[var(--accent)]"
                    >
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="mt-12 pt-5 border-t hairline text-center text-[10px] uppercase tracking-wider font-[family-name:var(--font-jetbrains-mono)] font-mono"
          style={{ color: "var(--ink-3)" }}
        >
          © {new Date().getFullYear()} FINZONE NETWORK
        </div>
      </div>
    </footer>
  );
}
